import { defineStore } from "pinia";

export const usePartsStore = defineStore("PartsStore", {
	state: () => ({
		detailLoader: false // 登録ボタン押下後のローディング処理
	})
	// 永続化
	// persist: true
});
